module.exports = __webpack_public_path__ + "237a5ccb95b108e342db024f0c4f47f7.pdf";